module.exports = __webpack_public_path__ + "img/404img.16e09549.png";